export default "__VITE_ASSET__CWTDebSq__"